import React from "react";

import { InputAdornment } from "@material-ui/core";

import { SOCIAL } from "../../../constants";
import { ErrorText, SocialInput } from "../../../widgets";
import { parseUsername } from "../../../utils";
import module_style from "../style.module.css";
import style from "Style.module.css";
import { Checkbox, Input } from "@my-scoot/component-library-legacy";
import { is_empty } from "utils/validations";
import ExlyImage from "common/Components/ExlyImage";

export const SocialLinks = (props) => {
  const {
    state,
    setField,
    errorState,
    setErrorMessage,
    errorHandlerToggle,
    disableAllEdits,
  } = props;

  const socialPlatforms = Object.values(SOCIAL);

  const [follower_count_check, set_follower_count_check] =
    React.useState(undefined);

  React.useEffect(() => {
    if (!is_empty(state?.social_info?.follower_count)) {
      let temp = {};
      for (let key in state?.social_info?.follower_count) {
        temp[key] = !is_empty(state?.social_info?.follower_count[key]);
      }
      set_follower_count_check({ ...temp });
    } else {
      set_follower_count_check({});
    }
  }, []);

  React.useEffect(() => {
    let follower_count = state?.social_info?.follower_count;
    if (!is_empty(follower_count)) {
      Object.entries(follower_count).map(([social_key, social_count]) => {
        if (
          !is_empty(social_count) &&
          is_empty(state?.social_info[social_key])
        ) {
          delete follower_count[social_key];
          setField(["social_info", `follower_count`], {
            ...follower_count,
          });
        }
      });
    }
  }, [state?.social_info]);

  const handleChange = (e, onlyUsername, key, validation, accessor) => {
    // If the user pastes a whole URL, extract the username out of it
    const fullURLRegex = new RegExp(
      `(?:https?)?(?:://)?(?:www.)?${key.toLowerCase()}.com/(.+)`
    );
    const val = (
      (onlyUsername && fullURLRegex.test(e.target.value)
        ? fullURLRegex.exec(e.target.value)[1]
        : e.target.value) || ""
    )
      .trim()
      .split(" ")
      .join("");

    if (onlyUsername && val) {
      setField(
        ["social_info", accessor],
        `https://${key.toLowerCase()}.com/${val}`
      );
    } else {
      setField(["social_info", accessor], val?.length ? val : null);
    }
    if (!onlyUsername) {
      setErrorMessage(`social_${accessor}`, validation?.(val || "") || null);
    }
  };

  return (
    <div className="tw-flex tw-flex-col tw-w-full">
      <div className="tw-text-[12px] tw-py-1 tw-text-[#27252270]">
        These links will be shown in your about section.
      </div>

      {socialPlatforms.map(
        ({
          key,
          color,
          icon: Icon,
          title,
          accessor,
          validation,
          onlyUsername,
        }) => {
          return (
            <div className="tw-pb-[1px]" key={key}>
              <div
                className={`tw-color-[#c0c4cc] tw-my-[6px] tw-border-solid tw-border-[1.5px] tw-border-[#CFCDC9] tw-rounded-[5px] pl-2 pr-2`}
              >
                <SocialInput
                  id={key}
                  // The getter and setter bindings need to parse out the social username
                  value={
                    (!onlyUsername
                      ? state?.social_info?.[accessor]
                      : parseUsername(
                          key.toLowerCase(),
                          state?.social_info?.[accessor]?.toLowerCase()
                        )) || ""
                  }
                  onChange={(e) => {
                    handleChange(e, onlyUsername, key, validation, accessor);
                  }}
                  {...errorHandlerToggle(`social_${accessor}`, {
                    noFocus: true,
                  })}
                  startAdornment={
                    <div>
                      <InputAdornment
                        position="start"
                        style={{ color, width: "max-content" }}
                      >
                        <ExlyImage
                          src={Icon}
                          className="tw-w-5"
                          alt="Social media icon"
                        />
                        {onlyUsername ? (
                          <div className="!tw-mr-1 !tw-w-fit">
                            &nbsp;
                            {key.toLowerCase()}
                            .com&nbsp;/
                          </div>
                        ) : null}
                      </InputAdornment>
                    </div>
                  }
                  placeholder={onlyUsername ? "username" : title}
                  className={`${module_style.input} pl-0`}
                  disabled={disableAllEdits}
                />
                {!is_empty(errorState?.[`social_${accessor}`]?.error) && (
                  <ErrorText
                    errorState={errorState}
                    fieldKey={`social_${accessor}`}
                  />
                )}

                {accessor !== SOCIAL.WEBSITE.accessor &&
                !is_empty(state?.social_info?.[accessor]) &&
                follower_count_check !== undefined ? (
                  <>
                    <div className={`${style.line} mb-2`}></div>

                    <div className={` mb-2 d-flex align-items-center`}>
                      <Checkbox
                        onChange={(e) => {
                          let checked = e.target.checked;
                          set_follower_count_check({
                            ...follower_count_check,
                            [accessor]: checked,
                          });

                          if (!checked) {
                            let temp = state?.social_info?.follower_count;
                            delete temp[accessor];
                            setField(["social_info", `follower_count`], {
                              ...temp,
                            });
                          } else {
                            setField(["social_info", `follower_count`], {
                              ...state?.social_info?.follower_count,
                              [accessor]: null,
                            });
                          }
                        }}
                        size="large"
                        checked={follower_count_check[accessor]}
                      />
                      <div className={`ml-2 small`}>
                        I also want to show follower count
                      </div>
                    </div>

                    {follower_count_check?.[accessor] && (
                      <div className={`mb-2`}>
                        <Input
                          error={
                            !is_empty(
                              errorState?.[`follower_count_${accessor}`]?.error
                            )
                          }
                          helperText={
                            !is_empty(
                              errorState?.[`follower_count_${accessor}`]?.error
                            )
                              ? "Invalid"
                              : null
                          }
                          value={state?.social_info?.follower_count?.[accessor]}
                          placeholder="Enter your follower count"
                          fullWidth
                          type="number"
                          onChange={(e) => {
                            const value = e.target.value;
                            setErrorMessage(`follower_count_${accessor}`, "");
                            setField(["social_info", `follower_count`], {
                              ...state?.social_info?.follower_count,
                              [accessor]: value ? parseInt(value) : null,
                            });
                          }}
                          size="thin"
                        />
                      </div>
                    )}
                  </>
                ) : null}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};
